import { render, staticRenderFns } from "./Orden_Ecommerce.vue?vue&type=template&id=1d57b953"
import script from "./Orden_Ecommerce.vue?vue&type=script&lang=js"
export * from "./Orden_Ecommerce.vue?vue&type=script&lang=js"
import style0 from "./Orden_Ecommerce.vue?vue&type=style&index=0&id=1d57b953&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports